const graduatesDirectionData = {
  jobOrientData: [
    [68, 56, 32, 64, 68, 114],
    [58, 56, 22, 84, 78, 104],
    [48, 76, 52, 44, 88, 94],
    [58, 36, 42, 64, 58, 144],
    [78, 46, 22, 74, 58, 124],
    [310, 296, 180, 330, 360, 580]
  ],
  hotJobsData: [
    [221, 75, 69, 67, 52, 6],
    [196, 85, 89, 47, 42, 6],
    [181, 105, 79, 47, 52, 9],
    [166, 125, 39, 47, 57, 11],
    [176, 95, 49, 67, 52, 16],
    [940, 577, 325, 275, 255, 48]
  ],
  salaryRankData: [
    [11300, 9600, 12500, 6500, 11000, 9700],
    [12300, 10600, 16500, 8500, 13000, 10700],
    [13300, 11600, 18500, 8500, 12000, 10100],
    [15300, 13600, 19500, 10500, 15000, 12700],
    [16300, 15600, 20500, 14500, 18000, 17700],
    [16300, 15600, 20500, 14500, 18000, 17700]
  ]
}

export default graduatesDirectionData